var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "11px",
    viewBox: "0 0 17 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Chevrons/Chevron down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.0524272,16.9907206 C12.7473301,17.2958177 12.2526699,17.2958177 11.9475728,16.9907206 C11.6424757,16.6856235 11.6424757,16.1909634 11.9475728,15.8858663 L19.6815532,8.15188587 C19.9866503,7.84678876 20.4813105,7.84678876 20.7864076,8.15188587 C21.0915047,8.45698297 21.0915047,8.95164311 20.7864076,9.25674021 L13.0524272,16.9907206 Z M13.0844706,15.7753032 C13.3895677,16.0804003 13.3895677,16.5750605 13.0844706,16.8801576 C12.7793735,17.1852547 12.2847134,17.1852547 11.9796163,16.8801576 L4.24563587,9.14617717 C3.94053876,8.84108007 3.94053876,8.34641993 4.24563587,8.04132283 C4.55073297,7.73622572 5.04539311,7.73622572 5.35049021,8.04132283 L13.0844706,15.7753032 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03_Future-Pricing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.2.6XL_EMP_EU_Pricing_Dealers-Call",
    transform: "translate(-1021.000000, -786.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(994.000000, 687.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Chevrons/Chevron-down",
    transform: "translate(23.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#253C67",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#102B4E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-39",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBlue);
export default __webpack_public_path__ + "static/media/chevron-down-blue.83bd5acb0c523c12192009cd02468989.svg";
export { ForwardRef as ReactComponent };